// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendarDay_SrPv0 {
	min-width: 750px;
	position: relative;

	tbody {
		position: relative;
	}
	th,
	td {
		width: 7%;
		min-height: 40px;
		height: 40px;
	}
	thead {
		position: sticky;
		top: 0;
		height: 73px;
		min-height: 73px;
		z-index: 1;
	}
	th:nth-child(1),
	td:nth-child(1) {
		position: relative;
		min-width: 70px;
		width: 70px;
		background: var(--fa-background);
		color: var(--_10a37f-background);
		border: none;
		padding: 2px 5px;
		font-size: 11px;
		font-weight: 500;
		text-align: right;
	}

	th {
		background: var(--_16c0982e-background);
		color: var(--_10a37f-background);
		border-color: var(--_16c0982e-background);
		padding: 2px 9px;
		font-size: 15px;
		font-weight: 600;
	}

	th:nth-child(1) {
		background: var(--fa-background);
	}

	th:nth-child(2),
	td:nth-child(2) {
		width: 100%;
	}
}
.leftTimezone_kUlrz {
	height: 65px;
	background: var(--fa-background);
	width: 70px;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	z-index: 999999;
	font-size: 11px;
	color: var(--_16c098-background);
	font-weight: 600;
	padding-bottom: 8px;
	border-radius: 5px;
}
.calendarDayHeader_y6M_R {
	min-height: 100px !important;
}

.firstTh_yrs5D {
	border-bottom: none !important;
	height: 40px !important;
	min-height: 40px !important;
	max-height: 40px !important;
	z-index: 9999999999;
}
.dayMonthContainer_ach0V {
	position: relative;
}
.dayMonthInnerContainerWrapper_E2hAp {
	position: absolute;
	padding-left: 5px;
	left: -1px;
	top: 0;
	padding-top: 5px;
	padding-bottom: 5px;
	width: calc(100% + 1px);
	background: var(--fa-background);
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: column;
}
.dayMonthInnerContainerWrapperWeek_W9i5P {
	position: absolute;
	padding-left: 5px;
	left: -1px;
	top: 0;
	padding-top: 5px;
	width: calc(100% + 1px);
	background: var(--fa-background);
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	z-index: 100000;
}
.dayMonthInnerContainer_W4rIJ {
	display: flex;
	padding-left: 5px;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
}

.dayText_uXzbL {
	color: var(--_16c098-background);
	font-weight: 500;
	font-size: 12px;
}

.selectedDayCircle_X4ffe {
	width: 45px;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	font-size: 26px;
	padding-right: 1px;
	font-weight: 500;
	background-color: var(--_16c098-background);
	color: var(--white-color);
}

.hourZoneWrapper_s8Tch {
	position: relative;
	background: var(--fa-background) !important;
	border-top: none !important;
}
.hourZoneInner_Z07b_ {
	position: absolute;
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	bottom: -1px;
	width: calc(100% - 10px);
	right: 10px;
	z-index: 100000;
	background: var(--fa-background);
	color: var(--_10a37f-background);
	padding: 2px 8px;
	font-size: 11px;
	font-weight: 500;
}
.hourContainer_YT5X4 {
	position: absolute;
	/* top: -9px; */
	right: 10px;
	/* background: var(--fa-background); */
	width: calc(100% - 10px);
	padding-right: 5px;
	z-index: 150000;
}
.selectedHourContent_V5G6a {
	display: flex;
	width: 100%;
	margin-right: 2px;
	padding: 2px 5px;
	flex-direction: column;
	border-radius: 4px;
	justify-content: flex-start;
	color: var(--white-color);
	align-items: flex-start;
	font-size: 12px;
	font-weight: 500;
	height: 100%;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	opacity: 0.8;
	position: relative;
	transition: all 0.2s ease-in-out;
	&:hover {
		opacity: 1;
	}
}
.floatingHourContent_ExwZW {
	display: flex;
	width: calc(100% - 11px);
	margin-right: 2px;
	padding: 2px 5px;
	flex-direction: column;
	border-radius: 4px;
	justify-content: flex-start;
	color: var(--white-color);
	align-items: flex-start;
	font-size: 12px;
	font-weight: 500;
	height: 100%;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	opacity: 0.8;
	position: absolute;
	top: 13px;
	left: 10px;
	transition: all 0.2s ease-in-out;
	z-index: 9999999999999;
	&:hover {
		opacity: 1;
	}
}

.hourContent_ZT7YL {
	padding-left: 10px;
	position: relative !important;
	display: flex;
	border-top: none !important;
	flex-direction: row;
}

.hourContentOutPosition_iCrxB{
	padding-left: 10px;
	display: flex;
	border-top: none !important;
	flex-direction: row;
}

.singleTask_difWD {
	display: flex;
	width: 300px;
	max-width: 400px;
	margin-right: 2px;
	padding: 2px 5px;
	flex-direction: column;
	border-radius: 4px;
	justify-content: flex-start;
	color: var(--white-color);
	align-items: flex-start;
	font-size: 11px;
	text-wrap: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	font-weight: 500;
	height: 15px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	opacity: 0.8;
	position: absolute;
	top: 13px;
	left: 200px;
	transition: all 0.2s ease-in-out;
	z-index: 99999999999999;
	&:hover {
		opacity: 1;
	}
}

`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/Calendars/CalendarDay.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,kBAAkB;;CAElB;EACC,kBAAkB;CACnB;CACA;;EAEC,SAAS;EACT,gBAAgB;EAChB,YAAY;CACb;CACA;EACC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,UAAU;CACX;CACA;;EAEC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;;CAEA;EACC,uCAAuC;EACvC,gCAAgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,gCAAgC;CACjC;;CAEA;;EAEC,WAAW;CACZ;AACD;AACA;CACC,YAAY;CACZ,gCAAgC;CAChC,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,uBAAuB;CACvB,eAAe;CACf,eAAe;CACf,gCAAgC;CAChC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,4BAA4B;AAC7B;;AAEA;CACC,8BAA8B;CAC9B,uBAAuB;CACvB,2BAA2B;CAC3B,2BAA2B;CAC3B,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,MAAM;CACN,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,gCAAgC;CAChC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,sBAAsB;AACvB;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,MAAM;CACN,gBAAgB;CAChB,uBAAuB;CACvB,gCAAgC;CAChC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,sBAAsB;CACtB,eAAe;AAChB;AACA;CACC,aAAa;CACb,iBAAiB;CACjB,mBAAmB;CACnB,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,2CAA2C;CAC3C,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,2BAA2B;AAC5B;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,YAAY;CACZ,wBAAwB;CACxB,WAAW;CACX,eAAe;CACf,gCAAgC;CAChC,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,sCAAsC;CACtC,wBAAwB;CACxB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,aAAa;CACb,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,2BAA2B;CAC3B,yBAAyB;CACzB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,wCAAwC;CACxC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;CAChC;EACC,UAAU;CACX;AACD;AACA;CACC,aAAa;CACb,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,2BAA2B;CAC3B,yBAAyB;CACzB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,wCAAwC;CACxC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,gCAAgC;CAChC,sBAAsB;CACtB;EACC,UAAU;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,kBAAkB;CAClB,2BAA2B;CAC3B,yBAAyB;CACzB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;CAChB,YAAY;CACZ,wCAAwC;CACxC,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,gCAAgC;CAChC,uBAAuB;CACvB;EACC,UAAU;CACX;AACD","sourcesContent":[".calendarDay {\n\tmin-width: 750px;\n\tposition: relative;\n\n\ttbody {\n\t\tposition: relative;\n\t}\n\tth,\n\ttd {\n\t\twidth: 7%;\n\t\tmin-height: 40px;\n\t\theight: 40px;\n\t}\n\tthead {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\theight: 73px;\n\t\tmin-height: 73px;\n\t\tz-index: 1;\n\t}\n\tth:nth-child(1),\n\ttd:nth-child(1) {\n\t\tposition: relative;\n\t\tmin-width: 70px;\n\t\twidth: 70px;\n\t\tbackground: var(--fa-background);\n\t\tcolor: var(--_10a37f-background);\n\t\tborder: none;\n\t\tpadding: 2px 5px;\n\t\tfont-size: 11px;\n\t\tfont-weight: 500;\n\t\ttext-align: right;\n\t}\n\n\tth {\n\t\tbackground: var(--_16c0982e-background);\n\t\tcolor: var(--_10a37f-background);\n\t\tborder-color: var(--_16c0982e-background);\n\t\tpadding: 2px 9px;\n\t\tfont-size: 15px;\n\t\tfont-weight: 600;\n\t}\n\n\tth:nth-child(1) {\n\t\tbackground: var(--fa-background);\n\t}\n\n\tth:nth-child(2),\n\ttd:nth-child(2) {\n\t\twidth: 100%;\n\t}\n}\n.leftTimezone {\n\theight: 65px;\n\tbackground: var(--fa-background);\n\twidth: 70px;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: center;\n\tz-index: 999999;\n\tfont-size: 11px;\n\tcolor: var(--_16c098-background);\n\tfont-weight: 600;\n\tpadding-bottom: 8px;\n\tborder-radius: 5px;\n}\n.calendarDayHeader {\n\tmin-height: 100px !important;\n}\n\n.firstTh {\n\tborder-bottom: none !important;\n\theight: 40px !important;\n\tmin-height: 40px !important;\n\tmax-height: 40px !important;\n\tz-index: 9999999999;\n}\n.dayMonthContainer {\n\tposition: relative;\n}\n.dayMonthInnerContainerWrapper {\n\tposition: absolute;\n\tpadding-left: 5px;\n\tleft: -1px;\n\ttop: 0;\n\tpadding-top: 5px;\n\tpadding-bottom: 5px;\n\twidth: calc(100% + 1px);\n\tbackground: var(--fa-background);\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n.dayMonthInnerContainerWrapperWeek {\n\tposition: absolute;\n\tpadding-left: 5px;\n\tleft: -1px;\n\ttop: 0;\n\tpadding-top: 5px;\n\twidth: calc(100% + 1px);\n\tbackground: var(--fa-background);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n\tz-index: 100000;\n}\n.dayMonthInnerContainer {\n\tdisplay: flex;\n\tpadding-left: 5px;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: column;\n}\n\n.dayText {\n\tcolor: var(--_16c098-background);\n\tfont-weight: 500;\n\tfont-size: 12px;\n}\n\n.selectedDayCircle {\n\twidth: 45px;\n\theight: 45px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 8px;\n\tfont-size: 26px;\n\tpadding-right: 1px;\n\tfont-weight: 500;\n\tbackground-color: var(--_16c098-background);\n\tcolor: var(--white-color);\n}\n\n.hourZoneWrapper {\n\tposition: relative;\n\tbackground: var(--fa-background) !important;\n\tborder-top: none !important;\n}\n.hourZoneInner {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\tbottom: -1px;\n\twidth: calc(100% - 10px);\n\tright: 10px;\n\tz-index: 100000;\n\tbackground: var(--fa-background);\n\tcolor: var(--_10a37f-background);\n\tpadding: 2px 8px;\n\tfont-size: 11px;\n\tfont-weight: 500;\n}\n.hourContainer {\n\tposition: absolute;\n\t/* top: -9px; */\n\tright: 10px;\n\t/* background: var(--fa-background); */\n\twidth: calc(100% - 10px);\n\tpadding-right: 5px;\n\tz-index: 150000;\n}\n.selectedHourContent {\n\tdisplay: flex;\n\twidth: 100%;\n\tmargin-right: 2px;\n\tpadding: 2px 5px;\n\tflex-direction: column;\n\tborder-radius: 4px;\n\tjustify-content: flex-start;\n\tcolor: var(--white-color);\n\talign-items: flex-start;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\theight: 100%;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n\tcursor: pointer;\n\tuser-select: none;\n\topacity: 0.8;\n\tposition: relative;\n\ttransition: all 0.2s ease-in-out;\n\t&:hover {\n\t\topacity: 1;\n\t}\n}\n.floatingHourContent {\n\tdisplay: flex;\n\twidth: calc(100% - 11px);\n\tmargin-right: 2px;\n\tpadding: 2px 5px;\n\tflex-direction: column;\n\tborder-radius: 4px;\n\tjustify-content: flex-start;\n\tcolor: var(--white-color);\n\talign-items: flex-start;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\theight: 100%;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n\tcursor: pointer;\n\tuser-select: none;\n\topacity: 0.8;\n\tposition: absolute;\n\ttop: 13px;\n\tleft: 10px;\n\ttransition: all 0.2s ease-in-out;\n\tz-index: 9999999999999;\n\t&:hover {\n\t\topacity: 1;\n\t}\n}\n\n.hourContent {\n\tpadding-left: 10px;\n\tposition: relative !important;\n\tdisplay: flex;\n\tborder-top: none !important;\n\tflex-direction: row;\n}\n\n.hourContentOutPosition{\n\tpadding-left: 10px;\n\tdisplay: flex;\n\tborder-top: none !important;\n\tflex-direction: row;\n}\n\n.singleTask {\n\tdisplay: flex;\n\twidth: 300px;\n\tmax-width: 400px;\n\tmargin-right: 2px;\n\tpadding: 2px 5px;\n\tflex-direction: column;\n\tborder-radius: 4px;\n\tjustify-content: flex-start;\n\tcolor: var(--white-color);\n\talign-items: flex-start;\n\tfont-size: 11px;\n\ttext-wrap: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-weight: 500;\n\theight: 15px;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n\tcursor: pointer;\n\tuser-select: none;\n\topacity: 0.8;\n\tposition: absolute;\n\ttop: 13px;\n\tleft: 200px;\n\ttransition: all 0.2s ease-in-out;\n\tz-index: 99999999999999;\n\t&:hover {\n\t\topacity: 1;\n\t}\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarDay": `calendarDay_SrPv0`,
	"leftTimezone": `leftTimezone_kUlrz`,
	"calendarDayHeader": `calendarDayHeader_y6M_R`,
	"firstTh": `firstTh_yrs5D`,
	"dayMonthContainer": `dayMonthContainer_ach0V`,
	"dayMonthInnerContainerWrapper": `dayMonthInnerContainerWrapper_E2hAp`,
	"dayMonthInnerContainerWrapperWeek": `dayMonthInnerContainerWrapperWeek_W9i5P`,
	"dayMonthInnerContainer": `dayMonthInnerContainer_W4rIJ`,
	"dayText": `dayText_uXzbL`,
	"selectedDayCircle": `selectedDayCircle_X4ffe`,
	"hourZoneWrapper": `hourZoneWrapper_s8Tch`,
	"hourZoneInner": `hourZoneInner_Z07b_`,
	"hourContainer": `hourContainer_YT5X4`,
	"selectedHourContent": `selectedHourContent_V5G6a`,
	"floatingHourContent": `floatingHourContent_ExwZW`,
	"hourContent": `hourContent_ZT7YL`,
	"hourContentOutPosition": `hourContentOutPosition_iCrxB`,
	"singleTask": `singleTask_difWD`
};
export default ___CSS_LOADER_EXPORT___;
